<script>
    import { db } from './stores.js';
    import Datepicker from './components/Datepicker.svelte'

    export let upcoming;
    let newCypher;
    let upcomingUpdated;

    console.log("upcoming: ", upcoming);

    function handleDateTimeChangeEvent(event){
        newCypher = event.detail.datetimeMs;
        console.log('newCypher: ', newCypher)
    }

    function addCypher() {
        // add to upcoming and save to Firebase
        if (newCypher){
            console.log("addCypher: ", newCypher);
            upcomingUpdated = [...upcoming, newCypher]
            save();
        }
    }

    function removeCypher(id) {
        // remove from upcoming and save to Firebase
        console.log('id: ', id);
        upcomingUpdated = upcoming.filter(cypher => cypher !== id);
        save();
    }

    function save() {
        // save to Firebase
        console.log("upcomingUpdated: ", upcomingUpdated);
        $db.collection("data").doc("status").set({
            upcoming: upcomingUpdated
        }, {merge: true}).then(() => {
            console.log("Upcoming cyphers successfully updated!");
        }).catch((error) => {
            console.error("Error updating upcoming cyphers: ", error);
        });

    }

</script>

<section>
    <div>
        add new Cypher <br/>
        <Datepicker on:datetimechange={handleDateTimeChangeEvent} /><br/>
        <button on:click="{() => addCypher()}">add</button>
    </div>
    <div>
        {#each upcoming as cypher (cypher)}
            <dwane-timer timer-deadline="{cypher}" countdown-start="3600000"></dwane-timer>
            <button on:click="{() => removeCypher(cypher)}">remove</button>
        {/each}
    </div>
</section>

<style>
    section {
        display: flex;
        align-items: center;
        justify-content: space-around;
        height: 100%;
    }
    dwane-timer {
        --dwane-timer-font-family: "Roboto Mono";
        --dwane-timer-weekday-font-size: clamp(1.5rem, 1.5vw, 2rem);
        --dwane-timer-date-font-size: clamp(1.5rem, 1.5vw, 2rem);
        --dwane-timer-time-font-size: clamp(1.5rem, 1.5vw, 2rem);
        --dwane-timer-countdown-font-size: 3vmax;
        opacity: 0;
        transition:opacity 0.4s ease-in;
    }
    dwane-timer:defined {
        opacity: 1;
    }
    button {
        cursor: pointer;
    }

</style>